import { API_CENTER } from "../../../services/api/api";
import { checkCSPFlash } from "../../../utils/utilities/crypto-pro/checkCSPFlash";
import { Response } from "../../../services/api/types/type";
import { ApplicationDocumentsToSign } from "../types/types";

/**
 * Функция для получения списка документов заявки с сервера. Функция выкидывает текст ошибки, если что-то пошло не по плану
 *
 * @async
 * @param {string} thumbprint
 * @param {(string | number)} applicationBankId
 * @returns {unknown}
 */
export const getDocumentsForSigningFromServer = async (
  thumbprint: string,
  applicationBankId: string | number
) => {
  const apiStart = new API_CENTER();
  // Проверка вставлена ли флешка

  await checkCSPFlash(thumbprint);

  // Получаем документы на подписание по id заявки
  const docsData: Response<ApplicationDocumentsToSign> =
    await apiStart.configAxios(
      "auth/sign/client-anketa/application/signature",
      {
        method: "POST",
        data: { appBankId: applicationBankId },
      },
      true,
      false
    );
  // Проверяем успешность получения данных
  if (!docsData.success) {
    throw new Error("Не удалось получить документы для подписания");
  }

  return docsData.data;
};
